/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const InputConstraintType = core.serialization.enum_(["required"]);
